import { handleH5Redirection, redirectionTo } from '@/utils/tools';
import React from 'react';
import './FoodyOrderCard.scss';
import { browserInstance as browser } from '@/utils/browser';

export enum OrderType {
  Shopee = 0,
  FoodVN = 1,
  Spx = 2,
  SPXE2C = 3
}
import { UseLiveChatSDKApp } from '@/config/core';

export function formatOrderInfoToUI(order: any) {
  const {
    order_sn: orderCode,
    order_type: orderServiceType,
    account_type: accountType,
    store_name: storeName,
    store_image: storeImage,
    first_dish_image: dishImage,
    first_dish_name: dishName,
    pick_up_address: pickUpAddress,
    drop_off_address: dropOffAddress,
    place_order_time: placeOrderTime,
    expected_delivered_time: driverEtaDropTime,
    receive_order_time: receiveTime,
    rn_link: rnLink,
    order_status: orderStatus,
    item_count: totalItem,
    price: paymentAmount,
  } = order;
  return {
    storeName,
    orderServiceType,
    orderStatus,
    storeImage,
    dishImage,
    dishName,
    orderCode,
    totalItem,
    paymentAmount,
    placeOrderTime,
    pickUpAddress,
    dropOffAddress,
    driverEtaDropTime,
    receiveTime,
    rnLink,
    accountType,
  };
}
function FoodyOrderCard({ orderMsg }: any) {
  const orderInfo = formatOrderInfoToUI(orderMsg);
  const FoodyOrderCard = window.FoodyOrder?.FoodyOrderCard;
  const { rnLink, orderServiceType } = orderInfo || {};
  if (FoodyOrderCard) {
    return (
      <FoodyOrderCard
        displayButton={false}
        displayTime={true}
        onClick={() => {
          if (!rnLink) {
            return;
          }
          // shopee app下不支持spx订单，暂时不跳转
          if (browser.shopeeApp && (orderServiceType === OrderType.Spx || orderServiceType === OrderType.SPXE2C)) {
            return;
          }
          if (UseLiveChatSDKApp.is()) {
            // 非shopee app直接走navigate方法
            handleH5Redirection(rnLink);
            return;
          }
          // 由于redirectionTo对于RN会自动拼接Rn链接的前缀，所以需要去掉前缀
          redirectionTo('food_order_page', { rnLink: rnLink.replace(/^\/?rn\//, '') });
        }}
        order={orderInfo || {}} />
    );
  } else {
    return <div></div>;
  }

}

export default FoodyOrderCard;
